import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { ALL_PRODUCTS } from "@/data";

export default function SearchOverlay({ open, onClose, navTo }) {
  const [q, setQ] = useState("");

  useEffect(() => {
    if (open) setQ("");
  }, [open]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const items = [
    { type: "পথ", title: "রঙের হাট", sub: "হস্তশিল্প • পোশাক • গৃহসজ্জা", view: "hat" },
    { type: "পথ", title: "রং ও মঞ্চ", sub: "বাউল • লোকসঙ্গীত • পরিবেশনা", view: "moncho" },
    { type: "দোকান", title: "পটচিত্র ঘর", sub: "পটুয়াদের নিজের ঘর", view: "shop", shop: "potchitra" },
    { type: "দোকান", title: "মৃৎশিল্পের ঘর", sub: "কুমারপাড়ার মৃৎশিল্পীদের উঠান", view: "shop", shop: "mrityo" },
    ...ALL_PRODUCTS.map((p) => ({
      type: "শিল্পকর্ম",
      title: p.title,
      sub: p.artisan,
      view: "shop",
      shop: p.id.startsWith("m") ? "mrityo" : "potchitra",
    })),
  ];

  const results = q.trim()
    ? items.filter((i) => (i.title + " " + i.sub).toLowerCase().includes(q.trim().toLowerCase()))
    : items;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[80] bg-dusk/95 backdrop-blur-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="search-overlay"
        >
          <div className="mx-auto max-w-2xl px-6 pt-24">
            <div className="flex items-center gap-3 border-b border-gold/25 pb-3">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#E69A3B" strokeWidth="1.8" strokeLinecap="round">
                <circle cx="11" cy="11" r="7" />
                <path d="m20 20-3.5-3.5" />
              </svg>
              <input
                data-testid="search-input"
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="গ্রামে কী খুঁজছেন? — পটচিত্র, বাউল, শাড়ি…"
                className="w-full bg-transparent font-display text-xl text-sand placeholder:text-sand/35 focus:outline-none"
              />
              <button
                data-testid="search-close"
                onClick={onClose}
                className="rounded-full p-2 text-sand/60 transition-colors hover:bg-sand/10 hover:text-sand"
                aria-label="বন্ধ করুন"
              >
                <X size={18} />
              </button>
            </div>

            <div className="mt-6 space-y-1 pb-10">
              {results.length === 0 && (
                <p className="py-10 text-center font-display text-lg text-sand/50">
                  এই পথে কিছু পাওয়া গেল না — অন্য নামে খুঁজে দেখুন।
                </p>
              )}
              {results.map((r) => (
                <button
                  key={r.type + r.title}
                  data-testid={`search-result-${r.view}`}
                  onClick={() => navTo(r.view, r.title, r.shop)}
                  className="group flex w-full items-center justify-between rounded-xl px-4 py-3 text-left transition-colors hover:bg-sand/5"
                >
                  <span>
                    <span className="block text-[11px] uppercase tracking-[0.2em] text-gold/60">{r.type}</span>
                    <span className="block font-display text-lg text-sand group-hover:text-gold">{r.title}</span>
                    <span className="block text-xs text-sand/50">{r.sub}</span>
                  </span>
                  <span className="font-latin text-sm italic text-sand/30 group-hover:text-gold">যান →</span>
                </button>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
